export default __webpack_public_path__ + "static/media/bg.7cfe36d6.jpeg";